import { getLogger } from '@blueberry/observability'

type WebCoreEventLevel = 'INFO' | 'WARNING' | 'ERROR'

type WebCoreEventOrigin = 'DOCTOR_EXPERIENCE' | 'WEB'

type WebCoreEventType =
  | 'Absence note created'
  | 'Accordion toggled'
  | 'Active message case toggled'
  | 'Asset fullscreen toggled'
  | 'Automated follow-up canceled'
  | 'Automated follow-up submitted'
  | 'Automated outreach modal dismissed'
  | 'Automated outreach modal opened'
  | 'Bulk case handoff'
  | 'Call initiated'
  | 'Case claimed'
  | 'Case handed off to Customer Support'
  | 'Case handed off to Doctor'
  | 'Case list loaded'
  | 'Case location updated'
  | 'Case returned to Doctor'
  | 'Case star toggled'
  | 'Chat message submitted'
  | 'Chat toggled'
  | 'Child note updated'
  | 'Dot phrase used'
  | 'Encounter submitted'
  | 'History of Present Illness summary copied into Private Doctor Note'
  | 'Login'
  | 'Message-only case status updated'
  | 'More chat history loaded'
  | 'Opened diagnostics platform'
  | 'Page loaded'
  | 'Parent note submitted'
  | 'In-person primary care provider added'
  | 'In-person primary care provider updated'
  | 'Pharmacy requested'
  | 'Opened prescription platform in new tab'
  | 'Private doctor note submitted'
  | 'Searched cases'
  | 'Video call created'
  | 'Viewed another asset'
  | 'Visit case flag updated'
  | 'Visit requested'
  | 'Websocket Connection Closed'
  | 'Network back online'
  | 'Parent note template selected'
  | 'A/P recommendations exposed to doctor'
  | 'A/P recommendation accepted by doctor'

type TrackEventOpts = {
  url?: string
  level?: WebCoreEventLevel
}

const logger = getLogger('track_event')

export const trackEvent = async (
  action: WebCoreEventType,
  origin?: WebCoreEventOrigin, // TODO make this required
  additionalData?: Record<string, unknown>,
  opts?: TrackEventOpts,
) => {
  logger.info(action, additionalData)

  try {
    const response = await fetch('/track_event', {
      method: 'POST',
      body: JSON.stringify({
        action,
        origin,
        // Stringified: the backend expects additional_data as a JSON string
        // and stores a dict as a non-queryable Python repr otherwise.
        additional_data: additionalData ? JSON.stringify(additionalData) : undefined,
        url: opts?.url ?? window.location.pathname,
        event_level: opts?.level ?? 'INFO',
      }),
    })

    if (!response.ok) {
      logger.error(
        'Error tracking event: Unexpected response code',
        response.status,
        response.statusText,
      )
      return
    }
  } catch (error) {
    logger.error('Error tracking event:', error)
  }
}
